export default "__VITE_ASSET__CuoH_Djd__"